import restGql from 'graphql-tag';

export const Discounts = restGql`#graphql
    query Discounts($institutionId: String!){
        result (institutionId: $institutionId) @rest(type: "DiscountsResponse", path: "/v2/discounts/{args.institutionId}/presets") {
            discounts {
                discountPresetId
                title
                ordering
                amount
                type
                accountId
            }
        }
    }
`;
